module.exports = __webpack_public_path__ + "static/media/opsmatic-inventory.4f5665b4.png";